import { observer } from 'mobx-react-lite'
import { View } from 'react-native'
import { PlayerCards } from '../../components'
import { useStore } from '../../models'
import { ThreeCardPlayer } from './ThreeCardPlayer'
import { useThreeCardSize } from './useThreeCardSizes'

export const ThreeCardPlayerHand = observer(() => {
  const size = useThreeCardSize()
  const isSmall = size === 'small'
  const {
    game: { myPlayer }
  } = useStore()

  return (
    <View style={{ gap: isSmall ? 50 : 65 }}>
      <PlayerCards cards={myPlayer?.cards} isThreeCard />
      <View style={{ justifyContent: 'center', alignItems: 'center', marginTop: 12 }}>
        <ThreeCardPlayer player={myPlayer} isBot={false} />
      </View>
    </View>
  )
})
